
import { Component, Vue } from 'vue-property-decorator'
import LearningProblem from '@/components/templates/study/LearningProblem.vue'
import { StudyModel } from '@/models/StudyModel'
import { CurriculumUnit } from '@/models/CurriculumUnit'

/**
 * 演習ページの入力サンプル
 */
@Component({
  components: {
    LearningProblem,
  },
})
export default class InputSample extends Vue {
  /** 読み込み完了フラグ */
  private isLoaded = false

  /** 単元情報 */
  private curriculumUnit: CurriculumUnit = {
    id: 1,
    name: '入力サンプル',
  }

  /** 小問情報 */
  private problem?: StudyModel.Problem

  /**
   * 初回処理
   */
  private async mounted(): Promise<void> {
    // 小問情報を生成
    this.problem = new StudyModel.Problem('P001_TEST', ['/img/dummy/problem/mondai01.png'], [])

    // 設問情報を生成(入力式)
    this.problem.addInputQuestion('Q001_TEST', '(1) 入力', 1, [null], ['cm'])
    this.problem.addInputQuestion('Q001_TEST', '(2) 入力', 2, [null, null], ['から', 'まで'])
    this.problem.addInputQuestion(
      'Q001_TEST',
      '(3) 入力',
      2,
      ['$\\dfrac{8}{21}$', '$3x^{2}$'],
      ['$\\dfrac{2}{77}$', '$2y^{7}$']
    )

    // 設問情報を生成(数式)
    this.problem.addNumericalFormulaQuestion('Q001_TEST', '(4) 数式', 1, [null], [null])
    this.problem.addNumericalFormulaQuestion('Q001_TEST', '(5) 数式', 2, [null, null], ['以上', '未満'])
    this.problem.addNumericalFormulaQuestion(
      'Q001_TEST',
      '(6) 数式',
      2,
      ['$\\dfrac{8}{21}$', '$3x^{2}$'],
      ['$\\dfrac{2}{77}$', '$2y^{7}$']
    )

    // 設問情報を生成(日本語)
    this.problem.addJapaneseQuestion('Q001_TEST', '(7) 日本語', 1, [null], [null])

    // 設問情報を生成(英語)
    this.problem.addEnglishQuestion('Q001_TEST', '(8) 英語', 1, [null], [null])

    // 設問情報を生成(択一式)
    this.problem.addSingleChoiceQuestion('Q001_TEST', '(9) 択一式', 'A=Bは成立する。これは', 'である', ['○', '×'])
    this.problem.addSingleChoiceQuestion('Q001_TEST', '(10) 択一式', null, null, [
      '選択肢1',
      '選択肢2',
      '選択肢3 この項目は文字列が長い場合に折り返しが発生しても正しく表示される事のテストのため設定しています',
      '選択肢4',
      '選択肢5',
      '選択肢6',
      '選択肢7',
      '選択肢8',
      '選択肢9',
      '選択肢10',
    ])

    this.isLoaded = true
  }

  /**
   * 答え合わせボタン押下時処理
   */
  private async eventSubmit(): Promise<void> {
    // nullブロック
    if (!this.problem) {
      return
    }

    this.$logger.log('===== 入力された解答内容 =====')
    this.problem.questions.forEach((question) => {
      this.$logger.log(`=== ${question.managementLabel}`)
      this.$logger.log(question.inputValues)
    })
  }

  /**
   * 戻るボタン押下時処理
   */
  private async eventReturn(): Promise<void> {
    alert('単元ページに遷移')
  }

  /**
   * トップページボタン押下時処理
   */
  private async eventTopPage(): Promise<void> {
    alert('トップページに遷移')
  }
}
